(function() { window.GUID_b2ac5ffe_4510_4ec3_8738_8b68feeaef16 = { getGuid: function() { return "b2ac5ffe-4510-4ec3-8738-8b68feeaef16"; } }; })();
var CS;
(function (CS) {
    class PerpetualRotator {
        constructor(container) {
            this.NoRepeat = true;
            this.ActualIndex = 0;
            this.GetDelegate = null;
            this.VisibleGroup = null;
            //Nombre de groupes qui vont rotationer :) beau mot
            this.GroupCount = 3;
            this.Groups = [];
            this.VisibleGroupHeight = 1000; // temporaire le temps qu'un groupe aye des données
            this.ScrollModeTimer = null;
            this.FixedModeTimer = null;
            this.InScrollMode = null;
            this.ScrollingSpeed = null;
            this.RefreshRate = null;
            this.HashCodeComparison = null;
            //Utilisé seulement lorsqu'on a plusieurs liste indépendante et que l'on veut que chacunes 
            //des listes scroll en même temps au même endroit.
            this.GroupsSynced = false;
            //Ici, je ne connais pas encore la hauteur réel d'un element, donc, j'indique un nombre d'item assez gros pour être sur de remplir l'écran
            //d'élément et ainsi détecter le mode qui devra être utilisé entre scroll et fixe. Autrement dit, si je demande 100 items et que le système
            //en retour moins que la taille de l'écran, je sais que le systeme decollera en mode fixe
            this.ItemsCount = 50;
            this.Container = container;
            //Appends les groupes qui vont tourner
            for (let i = 0; i < this.GroupCount; i++) {
                let group = $('<div class="PerpetualGroup" data-index="' + i + '"></div>');
                this.Groups.push(group);
                group.appendTo(this.Container);
            }
        }
        Start() {
            var me = this;
            me.VisibleGroup = me.Groups[0];
            //J'obtiens en premier lieu une seul fois un groupe pour déterminer le mode à adopter entre scroll et fix
            me.GetDataOfGroup(me.VisibleGroup, function (actualGroup, response) {
                me.OnDataReturn(actualGroup, response, function () {
                    me.DetectDisplayMode(actualGroup);
                });
            });
        }
        BindGetData(callback) {
            var me = this;
            me.GetDelegate = callback;
        }
        DetectDisplayMode(actualGroup) {
            let me = this;
            if (actualGroup.height() > me.Container.height()) {
                if (me.InScrollMode == null || !me.InScrollMode) {
                    me.StartScrollMode(me.ScrollingSpeed);
                    return true;
                }
            }
            else {
                if (me.InScrollMode == null || me.InScrollMode) {
                    me.StartFixedMode(me.RefreshRate);
                    return true;
                }
            }
            var groupParams = $('#GroupParams', actualGroup);
            var scrollingSpeed = parseInt(groupParams.data('scrollingspeed'), 10);
            var refreshRate = parseInt(groupParams.data('refreshrate'), 10);
            var changed = false;
            if (scrollingSpeed != me.ScrollingSpeed) {
                if (me.InScrollMode) {
                    me.StartScrollMode(scrollingSpeed);
                }
            }
            if (refreshRate != me.RefreshRate) {
                if (!me.InScrollMode) {
                    me.StartFixedMode(refreshRate);
                }
            }
            return false;
        }
        StartScrollMode(scrollingSpeed) {
            let me = this;
            me.ScrollingSpeed = scrollingSpeed;
            me.NoRepeat = false;
            me.InScrollMode = true;
            me.ClearTimers();
            me.ResetGroups();
            me.VisibleGroup = me.Groups[0];
            me.VisibleGroup.removeClass('IsFixed');
            me.GetDataOfGroups(0, function () {
                //Je m'assure d'enligner toutes les listes entre elles
                //Sinon, si j'ai 4 listes de large, vue que les données n'arriveront pas au même moment,
                //le margin-top ne sera pas le même au temps 0 de chacune d'elles.
                if (!this.GroupsSynced) {
                    me.SyncListsPosition();
                }
                me.ScrollModeTimer = setInterval(function () {
                    var lastTop = parseInt(me.VisibleGroup.css('margin-top'), 10);
                    var newTop = lastTop - 1;
                    me.VisibleGroup.css('margin-top', newTop + 'px');
                    //Lorsque le groupe visible disparait dans le haut
                    //de l'écran, je le retire et je commence à déplacer
                    //le groupe suivant. Le groupe qui a fut retirer est 
                    //ajouté à la fin pour ainsi tourner perpetuellement.
                    if (newTop < -me.VisibleGroup.height()) {
                        var isOutGroup = me.VisibleGroup;
                        isOutGroup.css('margin-top', 0);
                        //Je l'enleve du debut et je pitch le group qui vient de sortir de l'écran à la fin
                        isOutGroup.remove();
                        isOutGroup.appendTo(me.Container);
                        //Change pour le nouveau visibleGroup qui prend la place de celui qui vient de sortir
                        me.VisibleGroup = me.Container.children().first();
                        me.GetDataOfGroup(isOutGroup, function (actualGroup, response) {
                            me.OnDataReturn(actualGroup, response, function (realItemsCount) {
                                if (me.DetectDisplayMode(actualGroup)) {
                                    //Si je rentre ici, c'est que le mode flip, donc, je ne suis pas en mode scroll
                                    return;
                                }
                            });
                        });
                    }
                }, me.ScrollingSpeed);
            });
        }
        StartFixedMode(refreshRate) {
            var me = this;
            me.RefreshRate = refreshRate;
            me.NoRepeat = true;
            me.ClearTimers();
            me.ResetGroups();
            me.InScrollMode = false;
            me.VisibleGroup = me.Groups[0];
            me.VisibleGroup.addClass('IsFixed');
            me.GetDataOfGroup(me.VisibleGroup, function (actualGroup, response) {
                me.OnDataReturn(actualGroup, response, function () {
                    me.FixedModeTimer = setInterval(function () {
                        me.GetDataOfGroup(me.VisibleGroup, function (actualGroup, response) {
                            me.OnDataReturn(actualGroup, response, function () {
                                if (me.DetectDisplayMode(actualGroup)) {
                                    //Si je rentre ici, c'est que le mode flip, donc, je ne suis pas en mode fix
                                    return;
                                }
                            });
                        });
                    }, me.RefreshRate);
                });
            });
        }
        GetDataOfGroup(actualGroup, callback) {
            var me = this;
            var data = {
                startIndex: me.ActualIndex,
                itemsCount: me.ItemsCount,
                noRepeat: me.NoRepeat
            };
            if (me.GetDelegate != null) {
                me.GetDelegate.call(me, data, actualGroup, callback);
            }
        }
        GetDataOfGroups(groupIndex, callback) {
            var me = this;
            me.GetDataOfGroup(me.Groups[groupIndex], function (actualGroup, response) {
                me.OnDataReturn(actualGroup, response, function () {
                    groupIndex += 1;
                    if (groupIndex < me.GroupCount) {
                        me.GetDataOfGroups(groupIndex, callback);
                    }
                    else {
                        callback.call(this);
                    }
                });
            });
        }
        OnDataReturn(actualGroup, response, callback) {
            var me = this;
            if (response == "") {
                return;
            }
            let $response = $(response);
            let groupParams = $('#GroupParams', $response);
            let nextIndex = groupParams.data('nextindex');
            let perpetualItems = $('.PerpetualItem', $response);
            let realItemsCount = perpetualItems.length;
            me.CheckIfGroupParamsContainChanges(groupParams);
            if (me.NoRepeat) {
                me.ActualIndex = 0;
            }
            else if (nextIndex > 0) {
                me.ActualIndex = nextIndex;
            }
            else if (realItemsCount == 0) {
                me.ActualIndex = 0;
            }
            else {
                me.ActualIndex = me.ActualIndex + realItemsCount;
            }
            actualGroup.html($response);
            me.UpdateItemsNeededCount(perpetualItems.first().outerHeight(true));
            callback.call(this, realItemsCount);
        }
        CheckIfGroupParamsContainChanges(groupParams) {
            var me = this;
            var hashCodeComparison = groupParams.data('hashcodecomparison');
            var scrollingSpeed = groupParams.data('scrollingspeed');
            var refreshRate = groupParams.data('refreshrate');
            if (me.HashCodeComparison != null && me.HashCodeComparison != hashCodeComparison) {
                me.Container.trigger('NeedFullRefresh');
                me.HashCodeComparison = hashCodeComparison;
                return;
            }
            else {
                me.HashCodeComparison = hashCodeComparison;
            }
            if (!me.InScrollMode) {
                if (me.RefreshRate == null) {
                    me.RefreshRate = refreshRate;
                }
                else {
                    if (refreshRate != me.RefreshRate) {
                        me.StartFixedMode(refreshRate);
                        return;
                    }
                }
            }
            else {
                if (me.ScrollingSpeed == null) {
                    me.ScrollingSpeed = scrollingSpeed;
                }
                else {
                    if (scrollingSpeed != me.ScrollingSpeed) {
                        me.StartScrollMode(scrollingSpeed);
                        return;
                    }
                }
            }
        }
        SyncListsPosition() {
            var me = this;
            var groups = $('.PerpetualGroup[data-index=0]');
            var offsetMargin = 0;
            $.each(groups, function () {
                var group = $(this);
                if (!group.hasClass('IsFixed')) {
                    group.css('margin-top', offsetMargin);
                    var firstItemHeight = $('.PerpetualItem').first();
                    if (firstItemHeight != null && firstItemHeight.length > 0) {
                        offsetMargin += firstItemHeight.outerHeight();
                    }
                }
            });
            me.GroupsSynced = true;
        }
        ClearTimers() {
            var me = this;
            clearInterval(me.FixedModeTimer);
            clearInterval(me.ScrollModeTimer);
        }
        ResetGroups() {
            var me = this;
            me.ActualIndex = 0;
            me.GroupsSynced = false;
            for (var i = 0; i < me.GroupCount; i++) {
                var group = me.Groups[i];
                group.html("");
                group.remove();
                group.appendTo(me.Container);
                group.css('margin-top', 0);
            }
        }
        UpdateItemsNeededCount(itemHeight) {
            var me = this;
            if (itemHeight == 0 || itemHeight == null) {
                itemHeight = 30;
            }
            me.ItemsCount = Math.ceil(me.Container.height() / itemHeight);
            if (me.ItemsCount < 10) {
                me.ItemsCount = 10;
            }
        }
    }
    CS.PerpetualRotator = PerpetualRotator;
})(CS || (CS = {}));
/*
var CS = CS || {};

CS.PerpetualRotator = function (container) {

    this.Container = container;
    this.NoRepeat = true;
    this.ActualIndex = 0;
    this.GetDelegate = null;
    this.VisibleGroup = null;
    //Nombre de groupes qui vont rotationer :) beau mot
    this.GroupCount = 3;
    this.Groups = [];
    this.VisibleGroupHeight = 1000; // temporaire le temps qu'un groupe aye des données
    this.ScrollModeTimer = null;
    this.FixedModeTimer = null;
    this.InScrollMode = null;
    this.ScrollingSpeed = null;
    this.RefreshRate = null;
    this.HashCodeComparison = null;
    //Utilisé seulement lorsqu'on a plusieurs liste indépendante et que l'on veut que chacunes
    //des listes scroll en même temps au même endroit.
    this.GroupsSynced = false;

    //Ici, je ne connais pas encore la hauteur réel d'un element, donc, j'indique un nombre d'item assez gros pour être sur de remplir l'écran
    //d'élément et ainsi détecter le mode qui devra être utilisé entre scroll et fixe. Autrement dit, si je demande 100 items et que le système
    //en retour moins que la taille de l'écran, je sais que le systeme decollera en mode fixe
    this.ItemsCount = 50;

    //Appends les groupes qui vont tourner
    for (var i = 0; i < this.GroupCount; i++) {
        var group = $('<div class="PerpetualGroup" data-index="' + i + '"></div>');
        this.Groups.push(group);
        group.appendTo(this.Container);
    }

};

CS.PerpetualRotator.prototype = function () {

    Start = function () {
        var me = this;

        me.VisibleGroup = me.Groups[0];

        //J'obtiens en premier lieu une seul fois un groupe pour déterminer le mode à adopter entre scroll et fix
        me.GetDataOfGroup(me.VisibleGroup, function (actualGroup, response) {
            me.OnDataReturn(actualGroup, response, function () {

                me.DetectDisplayMode(actualGroup);

            });
        });
    },
    DetectDisplayMode = function (actualGroup) {
        var me = this;

        if (actualGroup.height() > me.Container.height()) {
            if (me.InScrollMode == null || !me.InScrollMode) {
                me.StartScrollMode(me.ScrollingSpeed);
                return true;
            }
        }
        else {
            if (me.InScrollMode == null || me.InScrollMode) {
                me.StartFixedMode(me.RefreshRate);
                return true;
            }
        }

        var groupParams = $('#GroupParams', actualGroup);
        var scrollingSpeed = parseInt(groupParams.data('scrollingspeed'));
        var refreshRate = parseInt(groupParams.data('refreshrate'));

        var changed = false;
        if (scrollingSpeed != me.ScrollingSpeed) {
            if (me.InScrollMode) {
                me.StartScrollMode(scrollingSpeed);
            }
        }
        if (refreshRate != me.RefreshRate) {
            if (!me.InScrollMode) {
                me.StartFixedMode(refreshRate);
            }
        }

        return false;
    },
    StartScrollMode = function (scrollingSpeed) {
        var me = this;

        me.ScrollingSpeed = scrollingSpeed;
        me.NoRepeat = false;
        me.InScrollMode = true;
        me.ClearTimers();
        me.ResetGroups();

        me.VisibleGroup = me.Groups[0];
        me.VisibleGroup.removeClass('IsFixed');
        me.GetDataOfGroups(0, function () {

            //Je m'assure d'enligner toutes les listes entre elles
            //Sinon, si j'ai 4 listes de large, vue que les données n'arriveront pas au même moment,
            //le margin-top ne sera pas le même au temps 0 de chacune d'elles.
            if (!this.GroupsSynced) {
                me.SyncListsPosition();
            }

            me.ScrollModeTimer = setInterval(function () {
                var lastTop = parseInt(me.VisibleGroup.css('margin-top'));
                var newTop = lastTop - 1;
                me.VisibleGroup.css('margin-top', newTop + 'px');

                //Lorsque le groupe visible disparait dans le haut
                //de l'écran, je le retire et je commence à déplacer
                //le groupe suivant. Le groupe qui a fut retirer est
                //ajouté à la fin pour ainsi tourner perpetuellement.
                if (newTop < -me.VisibleGroup.height()) {
                    var isOutGroup = me.VisibleGroup;
                    isOutGroup.css('margin-top', 0);
                    //Je l'enleve du debut et je pitch le group qui vient de sortir de l'écran à la fin
                    isOutGroup.remove();
                    isOutGroup.appendTo(me.Container);

                    //Change pour le nouveau visibleGroup qui prend la place de celui qui vient de sortir
                    me.VisibleGroup = me.Container.children().first();

                    me.GetDataOfGroup(isOutGroup, function (actualGroup, response) {
                        me.OnDataReturn(actualGroup, response, function (realItemsCount) {
                            if (me.DetectDisplayMode(actualGroup)) {
                                //Si je rentre ici, c'est que le mode flip, donc, je ne suis pas en mode scroll
                                return;
                            }
                        });
                    });
                }
            }, me.ScrollingSpeed);

        });
    },
    StartFixedMode = function (refreshRate) {
        var me = this;

        me.RefreshRate = refreshRate;

        me.NoRepeat = true;

        me.ClearTimers();
        me.ResetGroups();

        me.InScrollMode = false;

        me.VisibleGroup = me.Groups[0];
        me.VisibleGroup.addClass('IsFixed');

        me.GetDataOfGroup(me.VisibleGroup, function (actualGroup, response) {
            me.OnDataReturn(actualGroup, response, function () {
                me.FixedModeTimer = setInterval(function () {

                    me.GetDataOfGroup(me.VisibleGroup, function (actualGroup, response) {
                        me.OnDataReturn(actualGroup, response, function () {
                            if (me.DetectDisplayMode(actualGroup)) {
                                //Si je rentre ici, c'est que le mode flip, donc, je ne suis pas en mode fix
                                return;
                            }

                        });
                    });

                }, me.RefreshRate);
            });
        });

    },
    BindGetData = function (callback) {
        var me = this;

        me.GetDelegate = callback;
    },
    GetDataOfGroup = function (actualGroup, callback) {
        var me = this;


        var data = {
            startIndex: me.ActualIndex,
            itemsCount: me.ItemsCount,
            noRepeat: me.NoRepeat
        };

        if (me.GetDelegate != null) {
            me.GetDelegate.call(me, data, actualGroup, callback);
        }
    };
    GetDataOfGroups = function (groupIndex, callback) {
        var me = this;

        me.GetDataOfGroup(me.Groups[groupIndex], function (actualGroup, response) {
            me.OnDataReturn(actualGroup, response, function () {
                groupIndex += 1;
                if (groupIndex < me.GroupCount) {
                    me.GetDataOfGroups(groupIndex, callback);
                }
                else {
                    callback.call(this);
                }
            });
        });
    },
    OnDataReturn = function (actualGroup, response, callback) {
        var me = this;

        if (response == "")
            return;

        var $response = $(response);

        var groupParams = $('#GroupParams', $response);

        nextIndex = groupParams.data('nextindex');

        var perpetualItems = $('.PerpetualItem', $response);

        realItemsCount = perpetualItems.length;

        me.CheckIfGroupParamsContainChanges(groupParams);

        if (me.NoRepeat) {
            me.ActualIndex = 0;
        }
        else if (nextIndex > 0) {
            me.ActualIndex = nextIndex;
        }
        else if (realItemsCount == 0) {
            me.ActualIndex = 0;
        }
        else {
            me.ActualIndex = me.ActualIndex + realItemsCount;
        }

        actualGroup.html($response);

        me.UpdateItemsNeededCount(perpetualItems.first().outerHeight(true));

        callback.call(this, realItemsCount);
    },
    CheckIfGroupParamsContainChanges = function (groupParams) {
        var me = this;

        var hashCodeComparison = groupParams.data('hashcodecomparison');
        var scrollingSpeed = groupParams.data('scrollingspeed');
        var refreshRate = groupParams.data('refreshrate');

        if (me.HashCodeComparison != null && me.HashCodeComparison != hashCodeComparison) {
            me.Container.trigger('NeedFullRefresh');
            me.HashCodeComparison = hashCodeComparison;
            return;
        }
        else {
            me.HashCodeComparison = hashCodeComparison;
        }

        if (me.InFixedMode) {
            if (me.RefreshRate == null) {
                me.RefreshRate = refreshRate;
            }
            else {
                if (refreshRate != me.RefreshRate) {
                    me.StartFixedMode(refreshRate);
                    return;
                }
            }
        }
        else {
            if (me.ScrollingSpeed == null) {
                me.ScrollingSpeed = scrollingSpeed;
            }
            else {
                if (scrollingSpeed != me.ScrollingSpeed) {
                    me.StartScrollMode(scrollingSpeed);
                    return;
                }
            }
        }
    },
    SyncListsPosition = function () {
        var me = this;

        var groups = $('.PerpetualGroup[data-index=0]');

        var offsetMargin = 0;

        $.each(groups, function () {
            var group = $(this);
            if (!group.hasClass('IsFixed'))
            {
                group.css('margin-top', offsetMargin);
                var firstItemHeight = $('.PerpetualItem').first();
                if (firstItemHeight != null && firstItemHeight.length > 0) {
                    offsetMargin += firstItemHeight.outerHeight();
                }

            }
       
        });

        me.GroupsSynced = true;
    },
    ClearTimers = function () {
        var me = this;
        clearInterval(me.FixedModeTimer);
        clearInterval(me.ScrollModeTimer);
    },
    ResetGroups = function () {
        var me = this;

        me.ActualIndex = 0;

        me.GroupsSynced = false;

        for (var i = 0; i < me.GroupCount; i++) {
            var group = me.Groups[i];

            group.html("");
            group.remove();
            group.appendTo(me.Container);
            group.css('margin-top', 0);
        }
    },
    UpdateItemsNeededCount = function (itemHeight) {
        var me = this;

        if (itemHeight == 0 || itemHeight == null) {
            itemHeight = 30;
        }

        me.ItemsCount = Math.ceil(me.Container.height() / itemHeight);

        if (me.ItemsCount < 10) {
            me.ItemsCount = 10;
        }
    };
    return {
        Start: Start,
        StartScrollMode: StartScrollMode,
        StartFixedMode: StartFixedMode,
        BindGetData: BindGetData,
        CheckIfGroupParamsContainChanges: CheckIfGroupParamsContainChanges,
        GetDataOfGroup: GetDataOfGroup,
        GetDataOfGroups: GetDataOfGroups,
        OnDataReturn: OnDataReturn,
        SyncListsPosition: SyncListsPosition,
        ClearTimers: ClearTimers,
        ResetGroups: ResetGroups,
        DetectDisplayMode: DetectDisplayMode,
        UpdateItemsNeededCount: UpdateItemsNeededCount
    };

}();
*/ 

//# sourceMappingURL=cs.perpetualrotator.js.map
